<template>
  <div v-if="clientSecret">
    <v-row no-gutters>
      <v-col class="pb-5">
        <stripe-element-payment
          ref="paymentRef"
          :elements-options="elementsOptions"
          :pk="pk"
          :testMode="true"
          @element-ready="initPaymentButton"
          @error="logError"
          :confirm-params="getConfirmParams()"
        />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col class="d-flex justify-center justify-sm-end">
        <v-btn
          v-if="!isLoading"
          :height="styles.paymentButtons.height"
          :width="styles.paymentButtons.width"
          @click="() => $store.commit('orders/CLOSE_PAYMENT_DIALOG')"
          rounded
        >
          <div class="font-size-md-res text-capitalize">cancel</div>
        </v-btn>
        <v-btn
          v-if="!isLoading"
          class="ml-4"
          color="success"
          :height="styles.paymentButtons.height"
          :width="styles.paymentButtons.width"
          @click="pay"
          rounded
        >
          <div class="font-size-md-res text-capitalize">submit</div>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { StripeElementPayment } from "@vue-stripe/vue-stripe";
// import { StripeElementCard } from "@vue-stripe/vue-stripe";
import { getStoreURL } from "@/util.js";

const styles = {
  xs: {
    paymentButtons: {
      height: "38",
      width: "140",
    },
  },
  smAndUp: {
    paymentButtons: {
      height: "48",
      width: "180",
    },
  },
};

export default {
  name: "StripeOrder",
  components: {
    StripeElementPayment,
    // StripeElementCard
  },
  computed: {
    ...mapState({
      clientSecret: (state) => state.orders.payNow.clientSecret,
      orderId: (state) => state.orders.order.id,
      serviceType: (state) => state.orders.order.service,
      deliveryName: (state) => state.store.info.delivery_name,
    }),
    styles() {
      return this.$vuetify.breakpoint.xsOnly ? styles.xs : styles.smAndUp;
    },
  },
  data() {
    return {
      id: this.orderId,
      isLoading: true,
      pk: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      elementsOptions: {
        appearance: {
          theme: "stripe",
          variables: {
            colorPrimary: "#41b029",
            colorBackground: "#ffffff",
            colorText: "#2a2825",
            colorDanger: "#e21b23",
            fontFamily: "Roboto, sans-serif",
            // spacingAccordionItem: "4px",
            // spacingGridColumn: "4px",
            spacingGridRow: "24px",
            // spacingTab: "4px",
            spacingUnit: "4px",
          },
        }, // appearance options
      },
    };
  },
  mounted() {
    this.setClientSecret();
  },
  methods: {
    getConfirmParams() {
      const isBringgOrder =
        this.deliveryName === "Bringg" && this.serviceType === "DELIVERY";
      const storeUrl = isBringgOrder
        ? `confirmed/${this.orderId}`
        : `?orderId=${this.orderId}`;
      return {
        return_url: `${getStoreURL()}/${storeUrl}`, // success url
      };
    },
    logError(err) {
      console.log("error:", err);
    },
    initPaymentButton() {
      this.isLoading = false;
    },
    pay() {
      this.$refs.paymentRef.submit();
    },
    async setClientSecret() {
      this.elementsOptions.clientSecret = this.clientSecret;
    },
  },
};
</script>

<style>
#stripe-payment-element-errors {
  color: #df1b41;
}
</style>
